module.exports = __webpack_public_path__ + "img/y_2014.a7e101e3.png";